import { render, staticRenderFns } from "./Turntable.vue?vue&type=template&id=3579763b&scoped=true"
import script from "./Turntable.vue?vue&type=script&lang=js"
export * from "./Turntable.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/turntable.css?vue&type=style&index=0&id=3579763b&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3579763b",
  null
  
)

export default component.exports